import _ from 'lodash';
import { ICustomFieldQueryModel } from 'src/app/shared/components/odata-filter/models/custom-field-query.model';
import { DateRange } from 'src/app/shared/models/dateRange';
import { SeatStatus } from './seatStatus';
import { TeamStatusCount } from './teamStatusCount';

export class TeamQueryModel implements ITeamQueryModel {
  public id: string;
  public name: string;
  public publicName: string;
  public isArchived: boolean;
  public archiveDate: Date;
  public dateRange: DateRange;
  public updatedBy: string;
  public updatedOn: Date;
  public createdBy: string;
  public createdOn: Date;
  public status: string;
  public customFields: ICustomFieldQueryModel[] = [];
  public statusCounts: TeamStatusCount[] = [];
  public workspaceId: string;

  startDate: Date;
  endDate: Date;
  summary: ITeamSummaryQueryModel;

  public static parse(data: ITeamQueryModel): TeamQueryModel {
    if (!data) return null;

    let team = new TeamQueryModel();
    Object.assign(team, data);

    let counts = new Array<TeamStatusCount>();
    counts.push(new TeamStatusCount(SeatStatus.Picked, data.summary.picked));
    counts.push(new TeamStatusCount(SeatStatus.Invited, data.summary.invited));
    counts.push(new TeamStatusCount(SeatStatus.NoResponse, data.summary.noResponse));
    counts.push(new TeamStatusCount(SeatStatus.Declined, data.summary.declined));
    counts.push(new TeamStatusCount(SeatStatus.NoShow, data.summary.noShow));
    counts.push(new TeamStatusCount(SeatStatus.Accepted, data.summary.accepted));
    counts.push(new TeamStatusCount(null, data.summary.empty));
    team.setStatusCounts(counts);
    team.dateRange = new DateRange(data.startDate, data.endDate);
    return team;
  }

  private setStatusCounts(teamCounts: TeamStatusCount[]) {
    this.statusCounts = _.sortBy(teamCounts, (count) => count.rank);
  }
}
export interface ITeamQueryModel {
  id: string;
  name: string;
  publicName: string;
  isArchived: boolean;
  archiveDate: Date;
  startDate: Date;
  endDate: Date;
  updatedBy: string;
  updatedOn: Date;
  createdBy: string;
  createdOn: Date;
  status: string;
  summary: ITeamSummaryQueryModel;
  customFields: ICustomFieldQueryModel[];
  workspaceId: string;
}
export interface ITeamSummaryQueryModel {
  declined: number;
  noShow: number;
  empty: number;
  picked: number;
  accepted: number;
  invited: number;
  noResponse: number;
  roster: number;
}
